
import { Component, Vue } from 'vue-property-decorator'
import AddBrand from '@/views/goodsManage/commodity/template/AddBrand.vue'
import { getGoodsBrandList, GoodsBrandListDto } from '@/api/commodity'

@Component({
  components: {
    AddBrand
  }
})
export default class ChooseCustomer extends Vue {
  $refs!: {
    addBrand: AddBrand
  }

  showTemp = false
  brandList: GoodsBrandListDto[] | Record<string, any> = []
  selectBrand: GoodsBrandListDto | Record<string, any> = {}
  companyId = ''
  visible = false

  created () {
    this.getbrandList()
  }

  handleBack () {
    this.$eventBus.$emit('currentPage', 1)
    this.visible = false
  }

  handleHomeBack () {
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '现在退出则不会保存已修改内容，是否确认退出?',
      onOk: () => {
        this.$goHomeBack()
      },
    })
  }

  showModal (brandId: string) {
    this.visible = true
    this.brandList.forEach((item: GoodsBrandListDto) => {
      if (item.brandId === brandId) {
        this.selectBrand = item
      }
    })
  }

  getbrandList () {
    const params = {
      isPage: false
    }
    getGoodsBrandList(params).then((res) => {
      this.brandList = res.data || []
    })
  }

  // show (option:{companyId:string,brandId:string}){
  //   this.companyId=option.companyId
  //   this.brandId=option.brandId
  //   this.getbrandList()
  // }
  toAdd () {
    this.$refs.addBrand.showModal()
  }

  changeTag (brand: GoodsBrandListDto) {
    // 如果选择的是上一次选中的项，则取消选中
    if (this.selectBrand.brandId === brand.brandId) {
      this.selectBrand = {}
      return false
    }
    this.selectBrand = brand
  }

  handleSave () {
    this.$emit('on-save', this.selectBrand)
    this.handleBack()
  }
}
